import { ProjectValidationUnit } from '../../data-structures/project-validation';
import { UnitValue } from '../../data-structures/unit-value.model';
import { InputSummary } from '../../input-summary';

export interface GasUpgradingUnitInterface {
  uuid: string;
  name: string;
  nominalCapacityToggle: boolean;
  workingPeriod: UnitValue;
  nominalCapacity: UnitValue;
  minimumOutput: UnitValue;
  recoveryEfficiency: UnitValue;
}

export class GasUpgradingUnit {
  public uuid: string;
  public name: string;
  public recoveryEfficiency: UnitValue;
  public nominalCapacityToggle: boolean;
  public nominalCapacity: UnitValue;
  public minimumOutput: UnitValue;
  public workingPeriod: UnitValue;

  constructor(param: GasUpgradingUnitInterface = {
    uuid: undefined,
    name: '',
    nominalCapacityToggle: false,
    workingPeriod: new UnitValue(),
    nominalCapacity: new UnitValue(),
    minimumOutput: new UnitValue(),
    recoveryEfficiency: new UnitValue(),
  }) {
    this.uuid = param.uuid;
    this.name = param.name;
    this.nominalCapacityToggle = param.nominalCapacityToggle;
    this.workingPeriod = new UnitValue(param.workingPeriod);
    this.nominalCapacity = new UnitValue(param.nominalCapacity);
    this.minimumOutput = new UnitValue(param.minimumOutput);
    this.recoveryEfficiency = new UnitValue(param.recoveryEfficiency);
  }

  static deepCopy(guu: GasUpgradingUnit) {
    let copy;
    if (guu) {
      copy = new GasUpgradingUnit(guu);
      return copy;
    }
    throw new Error('gas upgrading unit deep copy failed');
  }

  getValid(): ProjectValidationUnit {
    const validationUnit = new ProjectValidationUnit();
    // if (this.name) {
    //   validationUnit.setValid(GasUpgradingPropName.Name);
    // } else {
    //   validationUnit.setInvalid(GasUpgradingPropName.Name, [GasUpgradingErrorMessage.MissingName]);
    // }
    // validationUnit.addModuleResults(this.workingPeriod.getValid(), GasUpgradingPropName.WorkingPeriod);
    // validationUnit.addModuleResults(this.nominalCapacity.getValid(), GasUpgradingPropName.NominalCapacity);
    // validationUnit.addModuleResults(this.recoveryEfficiency.getValid(), GasUpgradingPropName.RecoveryEfficiency);
    return validationUnit;
  }

  getInputSummary() {
    const inputSummary = new InputSummary();
    // inputSummary.inputs = InputSummaryUtils.performPush(
    //   inputSummary.inputs, GasUpgradingPropName.WorkingPeriod, this.workingPeriod);
    // inputSummary.inputs = InputSummaryUtils.performPush(
    //   inputSummary.inputs, GasUpgradingPropName.NominalCapacity, this.nominalCapacity);
    // inputSummary.inputs = InputSummaryUtils.performPush(
    //   inputSummary.inputs, GasUpgradingPropName.RecoveryEfficiency, this.recoveryEfficiency);
    return inputSummary;
  }

}

export enum GasUpgradingPropName {
  name = 'COMMON.NAME',
  workingPeriod = 'INPUT_SUMMARY.PLANT_SPECIFICATIONS.WORKING_PERIOD',
  nominalCapacity = 'INPUT_SUMMARY.PLANT_SPECIFICATIONS.NOMINAL_CAPACITY',
  minimumOutput = 'INPUT_SUMMARY.PLANT_SPECIFICATIONS.MINIMUM_OUTPUT',
  recoveryEfficiency = 'INPUT_SUMMARY.PLANT_SPECIFICATIONS.METHANE_RECOVERY',

  id_workingPeriod = 'working period',
  id_nominalCapacity = 'nominal capacity',
  id_minimumOutput = 'minimum output',
  id_recoveryEfficiency = 'methane recovery'
}

export enum GasUpgradingErrorMessage {
  MissingName = 'VALIDATION.MISSING_NAME'
}
